import { useContext } from 'react';
import { PermissionsContext } from '@/auth/PermissionsContext';

/**
 * Hook para acessar o contexto de permissões.
 * Fornece hasPermission, hasAnyPermission, hasAllPermissions, e isPrimary.
 */
export function usePermissions() {
  return useContext(PermissionsContext);
}

/**
 * Hook utilitário que verifica uma única permissão.
 * Em store read_only, só permissões view_* passam (via PermissionsContext).
 */
export function useRequirePermission(actionKey: string): boolean {
  const { hasPermission } = usePermissions();
  return hasPermission(actionKey);
}
